import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  logout,
  recoveryPassword,
  restartRecovery,
  signin
} from "../../actions/AuthAction";
import { Logo } from "../logo/Logo";
import "./freeAccountLanding.css";
import { Col, Row } from "antd";
// Button,
import Frame from "../../assets/images/file-upload-frame.svg";
import SignInModal from "../sign-in-modal/SignInModal";
import VideoIntroFreeAccountModal from "../sign-in-modal/VideoIntroFreeAccountModal";
import RegisterModal from "../register-modal/RegisterModal";
import ForgotPasswordModal from "../sign-in-modal/ForgotPasswordModal";
import VerifyCodeModal from "../sign-in-modal/VerifyCodeModal";
import CloseWindowModal from "../sign-in-modal/CloseWindowModal";
import SuccessRegisterModal from "../register-modal/SuccessRegisterModal";
import BunkeyAPI from "../../api/BunkeyAPI";
import { sendNotification, VERSION } from "../../utils";
// import { freePlanPrice } from '../../utils/constants';

export class FreeAccountLanding extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalSignIn: false,
      showModalForgotPassword: false,
      showModalRegister: false,
      showModalVideoIntro: false,
      showModalVerifyCode: false,
      showModalSuccessRegister: false,
      userData: null,
      signUpResponse: null,
      registering: false,
      showCloseWindowModal: false
    };
  }

  handleShowModalSignIn = () => {
    this.setState({
      showModalSignIn: true
    });
  };

  handleShowModalForgotPassword = () => {
    this.setState({
      showModalForgotPassword: true
    });
  };

  handleHiddenModalSignIn = () => {
    this.setState({
      showModalSignIn: false
    });
  };
  handleShowCloseWindowModal = () => {
    this.setState({
      showCloseWindowModal: true
    });
  };

  handleHiddenModalSignIn = () => {
    this.setState({
      showModalSignIn: false
    });
  };

  handleHiddenForgotPassword = () => {
    this.setState({
      showModalForgotPassword: false
    });
  };

  handleShowModalVideoIntro = () => {
    this.setState({
      showModalVideoIntro: true
    });
  };

  handleHiddenModalVideoIntro = () => {
    this.setState({
      showModalVideoIntro: false
    });
  };

  handleShowModalRegister = () => {
    this.setState({
      showModalRegister: true
    });
  };

  handleHiddenModalRegister = () => {
    this.setState({
      showModalRegister: false
    });
  };

  handleShowModalSuccessRegister = () => {
    this.setState({
      showModalSuccessRegister: true
    });
  };

  handleHiddenModalVerifyCode = () => {
    this.setState({
      showModalVerifyCode: false
    });
  };

  handleShowInsertCodeVerify = () => {
    this.setState({
      showModalVerifyCode: true,
      showModalSuccessRegister: false
    });
  };
  handlecloseverifycode = () => {
    this.setState({
      showModalVerifyCode: false,
      showModalRegister: true
    });
  };

  handleSignUp = userData => {
    const { intl } = this.props;
    const phone = `${userData.phoneCode}${userData.phoneNumber}`;
    this.setState({
      registering: true
    });
    BunkeyAPI({
      url: `/clients/signupFreeClient`,
      method: "POST",
      data: {
        agent: userData.name,
        name: userData.agent,
        phone: phone,
        email: userData.email,
        businessType: userData.serviceSelected
      }
    })
      .then(resp => {
        if (resp.data.code) {
          this.setState({
            registering: false
          });
          sendNotification(
            "error",
            intl,
            resp.data.message === "User is Already taken"
              ? "El usuario ya está registrado"
              : resp.data.message
          );
          return;
        }
        this.setState({
          registering: false,
          userData: userData,
          signUpResponse: {
            ...resp.data,
            companyName: userData.name
          }
        });
        this.handleHiddenModalRegister();

        this.handleShowModalSuccessRegister();
      })
      .catch(err => {
        this.setState({
          registering: false
        });
      });
  };
  render() {
    const { intl } = this.props;
    const {
      showModalSignIn,
      showModalForgotPassword,
      showModalVideoIntro,
      showModalRegister,
      showModalVerifyCode,
      showModalSuccessRegister,
      registering,
      signUpResponse,
      showCloseWindowModal
    } = this.state;

    const hash = "#";
    const LINK_TO_DISCOVER_US = "https://bunkeylatam.com/descubrenos/";
    const LINK_TO_BUNKEY_LATAM = "https://bunkeylatam.com/";

    return (
      <div
        style={{
          background: "#F5F5F5",
          height: "100vh"
        }}
      >
        {/* floating bubbles */}
        <ul id="shape" className="bubbles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <Row
          type={"flex"}
          justify={"center"}
          style={{ height: "10vh", alignItems: "center" }}
          span={20}
        >
          <Col xxl={14} xl={14} lg={14} md={20} sm={20} xs={20}>
            <div
              style={{
                width: "100%"
              }}
            >
              <Logo
                onClick={() => {
                  window.open(LINK_TO_BUNKEY_LATAM, "_blank");
                }}
              />
            </div>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6}>
            <a
              className={"menu-item"}
              onClick={this.handleShowModalSignIn}
              href={hash}
            >
              {intl.formatMessage({ id: "menu_sign.login" })}
            </a>
          </Col>
          {/* <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6}>
            <a className={'menu-item'} onClick={this.handleShowModalRegister} href={hash}>{intl.formatMessage({ id: 'menu_sign.register' })}</a>
          </Col> */}
          <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6}>
            <a
              className={"menu-item"}
              href={LINK_TO_DISCOVER_US}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: "menu_sign.whats" })}
            </a>
          </Col>
        </Row>
        <Row
          type={"flex"}
          justify={"center"}
          align={"middle"}
          style={{ height: "90vh" }}
        >
          <Col xxl={10} xl={10} lg={10} md={20} sm={20} xs={20}>
            <div className="free-account-title">
              {intl.formatMessage({ id: "free-account-landing-create1" })}
              <span style={{ color: "#3598CD" }}>
                {intl.formatMessage({ id: "free-account-landing-create2" })}
              </span>{" "}
              {intl.formatMessage({ id: "free-account-landing-create3" })}
            </div>
            <div className="free-account-subtitle">
              {intl.formatMessage({ id: "free-account-landing-create4" })}
              <span style={{ color: "#3598CD", fontWeight: 700 }}>
                {intl.formatMessage({ id: "free-account-landing-create5" })}
              </span>{" "}
              {intl.formatMessage({ id: "free-account-landing-create6" })}
            </div>
            {/* <div style={{ display: 'flex', gap: 20, }}>
              <button
                className='free-account-m-button'
                onClick={this.handleShowModalRegister}
              >
                {`${intl.formatMessage({ id: 'free-account-landing-create7' })} (${freePlanPrice} USD)`} 
              </button>
              
              <Button
                type={'primary'}
                shape={'circle'}
                size={'large'}
                style={{ height: 57, width: 57, }}
                onClick={this.handleShowModalVideoIntro}
                // onClick={this.handleShowCloseWindowModal}
              >
                <img src="/images/icons/play-icon.svg" alt="play icon" />
              </Button>
            </div> */}
          </Col>
          <Col xxl={10} xl={10} lg={10} md={20} sm={20} xs={20}>
            <img
              src={Frame}
              alt="back file charges"
              className="free-acount-m-image"
            />
          </Col>
          <div
            style={{
              position: "fixed",
              bottom: 0,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "0.8em"
            }}
          >
            <span>v{VERSION}</span>
          </div>
        </Row>

        {showModalSignIn && (
          <SignInModal
            handleHiddenModalSignIn={this.handleHiddenModalSignIn}
            handleShowModalRegister={this.handleShowModalRegister}
            handleShowModalForgotPassword={this.handleShowModalForgotPassword}
            showModalSignIn={showModalSignIn}
          />
        )}
        {showModalForgotPassword && (
          <ForgotPasswordModal
            handleHiddenForgotPassword={this.handleHiddenForgotPassword}
            handleShowModalSignIn={this.handleShowModalSignIn}
            showModalForgotPassword={showModalForgotPassword}
          />
        )}

        {showModalRegister && (
          <RegisterModal
            handleHiddenModalRegister={this.handleHiddenModalRegister}
            handleShowModalSignIn={this.handleShowModalSignIn}
            handleShowModalSuccessRegister={this.handleShowModalSuccessRegister}
            showModal={showModalRegister}
            handleSignUp={this.handleSignUp}
            registering={registering}
          />
        )}

        {showModalVideoIntro && (
          <VideoIntroFreeAccountModal
            handleHiddenModal={this.handleHiddenModalVideoIntro}
            showModal={showModalVideoIntro}
          />
        )}

        {showModalVerifyCode && (
          <VerifyCodeModal
            handleHiddenModal={this.handleHiddenModalVerifyCode}
            showModal={showModalVerifyCode}
            userData={this.state.userData}
            handlecloseverifycode={this.handlecloseverifycode}
            signUpResponse={signUpResponse}
            handleShowCloseWindowModal={this.handleShowCloseWindowModal}
          />
        )}

        {showModalSuccessRegister && (
          <SuccessRegisterModal
            showModal={showModalSuccessRegister}
            handleShowInsertCodeVerify={this.handleShowInsertCodeVerify}
          />
        )}
        <CloseWindowModal showCloseWindowModal={showCloseWindowModal} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.authUser.user,
  error: state.authUser.error,
  token: state.authUser.token,
  isFetching: state.authUser.isFetching,
  passRecovered: state.authUser.passRecovered,
  newColor:
    state.authUser.user && state.authUser.user.color
      ? state.authUser.user.color
      : "#2E97CF"
});

const mapDispatchToProps = {
  signin,
  logout,
  recoveryPassword,
  restartRecovery
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(FreeAccountLanding))
);
